import { registerLocaleData } from '@angular/common';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import ru from '@angular/common/locales/ru';
import {
  EnvironmentProviders,
  ErrorHandler,
  importProvidersFrom,
  inject,
  Injector,
  LOCALE_ID,
  Provider,
  provideZoneChangeDetection,
} from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { kk_KZ, NZ_I18N, ru_RU } from 'ng-zorro-antd/i18n';
import { cachingInterceptorProviders } from '../services';
import { ErrorService, GlobalErrorHandlerService } from '../services/errors';

registerLocaleData(ru);

export const appBaseProvidersConfig: Array<Provider | EnvironmentProviders> = [
  provideHttpClient(withInterceptorsFromDi()),
  provideZoneChangeDetection({ eventCoalescing: true }),
  importProvidersFrom(BrowserAnimationsModule),
  {
    provide: ErrorHandler,
    useClass: GlobalErrorHandlerService,
    deps: [ErrorService],
  },
  cachingInterceptorProviders,
  { provide: LOCALE_ID, useValue: 'ru' },
  {
    provide: NZ_I18N,
    useFactory: () => {
      const localId = inject(LOCALE_ID);
      switch (localId) {
        case 'ru':
          return ru_RU;
        case 'kk':
        default:
          return kk_KZ;
      }
    },
  },
];
